const LEGACY_PROFILE_FALLBACK_URL = '/img/default/profile-pic.webp'

export const DEFAULT_PROFILE_AVATAR_URLS = Array.from(
  { length: 9 },
  (_, index) =>
    `/img/default/profile-avatars/default-avatar-${index + 1}.webp`,
)

function getStableHash(value) {
  let hash = 2166136261

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }

  return hash >>> 0
}

export const getDefaultUserProfilePictureUrl = (userOrId) => {
  const userId =
    typeof userOrId === 'string' ? userOrId : userOrId?.id || userOrId?.userId

  if (!userId) return null

  const avatarIndex =
    getStableHash(String(userId)) % DEFAULT_PROFILE_AVATAR_URLS.length

  return DEFAULT_PROFILE_AVATAR_URLS[avatarIndex]
}

/**
 * Gets a user's profile picture URL based on priority order:
 * 1. User's uploaded logoImgUrl
 * 2. Deterministic generated default avatar from user.id
 * 3. Explicit fallbackUrl or legacy profile fallback
 *
 * @param {Object} user - The user object containing profile information
 * @param {Object} [options] - Additional options for the function
 * @param {string} [options.fallbackUrl] - URL to use if no user ID is available
 * @returns {string} The URL of the profile picture or fallback image
 */
export const getUserProfilePictureUrl = (user, options = {}) => {
  const { fallbackUrl = LEGACY_PROFILE_FALLBACK_URL } = options

  if (!user) return fallbackUrl

  if (user.logoImgUrl) {
    return user.logoImgUrl
  }

  return getDefaultUserProfilePictureUrl(user) || fallbackUrl
}
